// Список категорій + інлайн-перемикач "активна".
// Створення нової — невелика форма зверху.

import { useState } from 'react';
import { api, ApiError, type AdminCategory } from '../../lib/api';
import { useFetch } from '../../lib/useFetch';
import { Loader } from '../../components/Loader';
import { ErrorView } from '../../components/ErrorView';

export function AdminCategories() {
  const list = useFetch(() => api.admin.listCategories(), []);
  const [slug, setSlug] = useState('');
  const [nameUk, setNameUk] = useState('');
  const [creating, setCreating] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleCreate(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setCreating(true);
    try {
      await api.admin.createCategory({ slug: slug.trim(), nameUk: nameUk.trim() });
      setSlug('');
      setNameUk('');
      list.reload();
    } catch (e) {
      setError(e instanceof ApiError ? e.message : 'Помилка створення');
    } finally {
      setCreating(false);
    }
  }

  async function toggleActive(c: AdminCategory) {
    try {
      await api.admin.updateCategory(c.id, { isActive: !c.isActive });
      list.reload();
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Помилка');
    }
  }

  return (
    <div className="space-y-4 p-4">
      <form onSubmit={handleCreate} className="card space-y-2">
        <div className="grid grid-cols-2 gap-2">
          <input
            value={slug}
            onChange={(e) => setSlug(e.target.value)}
            placeholder="slug (latin)"
            className="rounded-lg bg-tg-bg px-3 py-2 text-sm"
            required
          />
          <input
            value={nameUk}
            onChange={(e) => setNameUk(e.target.value)}
            placeholder="Назва українською"
            className="rounded-lg bg-tg-bg px-3 py-2 text-sm"
            required
          />
        </div>
        <button type="submit" disabled={creating} className="btn-primary w-full">
          {creating ? 'Створення…' : '+ Додати категорію'}
        </button>
      </form>

      {error && <div className="card border border-tg-destructive text-sm text-tg-destructive">{error}</div>}
      {list.loading && <Loader />}
      {list.error && <ErrorView error={list.error} onRetry={list.reload} />}

      {list.data?.map((c) => (
        <div key={c.id} className="card flex items-center justify-between">
          <div className="min-w-0 flex-1">
            <div className="font-medium">{c.nameUk}</div>
            <div className="text-xs text-tg-hint">
              <code>{c.slug}</code> · {c._count.questions} питань
            </div>
          </div>
          <button
            onClick={() => toggleActive(c)}
            className={`ml-2 rounded-lg px-3 py-1.5 text-xs ${
              c.isActive ? 'bg-tg-success text-white' : 'bg-tg-secondary-bg text-tg-hint'
            }`}
          >
            {c.isActive ? 'Активна' : 'Прихована'}
          </button>
        </div>
      ))}
    </div>
  );
}
